var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_12987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.5H10.6667C11.5507 14.5 12.3986 14.1488 13.0237 13.5237C13.6488 12.8986 14 12.0507 14 11.1667V9.16667C14 8.63623 13.7893 8.12753 13.4142 7.75245C13.0391 7.37738 12.5304 7.16667 12 7.16667H11.3333V5.83333C11.3333 4.94928 10.9821 4.10143 10.357 3.47631C9.7319 2.85119 8.88406 2.5 8 2.5H5.33333C4.44928 2.5 3.60143 2.85119 2.97631 3.47631C2.35119 4.10143 2 4.94928 2 5.83333V11.1667C2 12.0507 2.35119 12.8986 2.97631 13.5237C3.60143 14.1488 4.44928 14.5 5.33333 14.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 6.16602C4.6665 5.9008 4.77186 5.64645 4.9594 5.45891C5.14693 5.27137 5.40129 5.16602 5.6665 5.16602H7.6665C7.93172 5.16602 8.18607 5.27137 8.37361 5.45891C8.56115 5.64645 8.6665 5.9008 8.6665 6.16602C8.6665 6.43123 8.56115 6.68559 8.37361 6.87312C8.18607 7.06066 7.93172 7.16602 7.6665 7.16602H5.6665C5.40129 7.16602 5.14693 7.06066 4.9594 6.87312C4.77186 6.68559 4.6665 6.43123 4.6665 6.16602Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 10.834C4.6665 10.5688 4.77186 10.3144 4.9594 10.1269C5.14693 9.93934 5.40129 9.83398 5.6665 9.83398H10.3332C10.5984 9.83398 10.8527 9.93934 11.0403 10.1269C11.2278 10.3144 11.3332 10.5688 11.3332 10.834C11.3332 11.0992 11.2278 11.3536 11.0403 11.5411C10.8527 11.7286 10.5984 11.834 10.3332 11.834H5.6665C5.40129 11.834 5.14693 11.7286 4.9594 11.5411C4.77186 11.3536 4.6665 11.0992 4.6665 10.834Z",
    stroke: "#363636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_12987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon);
export default __webpack_public_path__ + "static/media/blog-icon.40a612e1958deacb0b7ce10b39a1b508.svg";
export { ForwardRef as ReactComponent };